<script setup lang="ts">
    import { useDisplay } from 'vuetify';
    import { useAppStore } from '#imports';

    /* Store variables */
    const { isMenu, isMobile, siteName, txt, heroSection, skillSetSection, devSection, artSection, contactSection } = storeToRefs(useAppStore());

    /* Private variables */
    const _display = useDisplay();
    const _tab = ref<string>('1');
    const _extensionMultiplier = ref<number>(0);
    const _extensionHeight = 28;

    function onScroll(): void {
        if (window.top && heroSection.value && skillSetSection.value && devSection.value && artSection.value && contactSection.value) {
            _extensionMultiplier.value = window.top.scrollY >= 8 ? 1 : 0;

            console.log(window.top.scrollY)
            console.log(heroSection.value.$el.clientHeight)
            console.log(skillSetSection.value.clientHeight)
            if (window.top.scrollY >= heroSection.value.$el.clientHeight * 0.75 + skillSetSection.value.clientHeight + devSection.value.clientHeight + artSection.value.clientHeight) {
                _tab.value = '4';
            }
            else if (window.top.scrollY >= heroSection.value.$el.clientHeight * 0.75 + skillSetSection.value.clientHeight + devSection.value.clientHeight) {
                _tab.value = '3';
            }
            else if (window.top.scrollY >= heroSection.value.$el.clientHeight * 0.75 + skillSetSection.value.clientHeight) {
                _tab.value = '2';
            }
            else {
                _tab.value = '1';
            }
        }
    }

    onMounted(() => {
        isMobile.value = computed(() => { return _display.mobile.value; });
        isMenu.value = !_display.mobile.value;
        window.addEventListener("scroll", onScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener("scroll", onScroll);
    });
</script>

<template>
    <v-app-bar extended :extension-height="_extensionHeight * _extensionMultiplier" :elevation="_extensionMultiplier * 4">
        <div class="ml-3" style="position: absolute; transition: 100ms;"
            :style="_extensionMultiplier === 0 ? 'opacity: 0; margin-top: -3rem;' : 'opacity: 1; margin-top: 0rem;'">
            <p class="brand-font color-primary mb-n1">
                {{ siteName }}
            </p>
            <p class="text-caption color-primary" style="opacity: 0.6;">{{ txt.pages.home.subtitle }}</p>
        </div>
        <SiteSettings />
        <template v-slot:extension>
            <v-tabs
                v-model="_tab"
                bg-color="surfaceDark"
                class="align-end"
                color="primary">
                <v-tab value="1" variant="text" flat @click.stop="skillSetSection?.scrollIntoView({ behavior: 'smooth', block: 'start' })">{{ txt.skillset }}</v-tab>
                <v-tab value="2" variant="text" flat @click.stop="devSection?.scrollIntoView({ behavior: 'smooth', block: 'start' })">{{ txt.pages.development.nav }}</v-tab>
                <v-tab value="3" variant="text" flat @click.stop="artSection?.scrollIntoView({ behavior: 'smooth', block: 'start' })">{{ txt.pages.art.nav }}</v-tab>
                <v-tab value="4" variant="text" flat @click.stop="contactSection?.scrollIntoView({ behavior: 'smooth', block: 'start' })">{{ txt.pages.contact.nav }}</v-tab>
            </v-tabs>
        </template>
    </v-app-bar>
</template>